import styled from 'styled-components';

export const Container = styled.div`
    .dropdown-menu {
        color: ${props => {
            return props.theme.dark_mode ? '#fff' : '#252525';
        }};
        background: ${props => {
            return props.theme.dark_mode ? '#252525' : '#fff';
        }};
    }
`;

export const Item = styled.li`
    .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 10px;

        i {
            font-size: 22px;
        }

        span {
            font-size: 12px;
        }
    }

    :hover {
        cursor: pointer;
        border-radius: 5px;
        color: ${props => props.theme.palette.primary.main} !important;
        border: 1px solid ${props => props.theme.palette.primary.main};
    }
`;
